<template>
  <section>
    <bank-offer-list :query="query" />
  </section>
</template>

<script>
import BankOfferList from '@/components/company/BankOfferList'

export default {
  name: 'BankOffers',
  components: {
    BankOfferList
  },

  data() {
    const { query } = this.$route

    return {
      query: query
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  }
}
</script>
